import { render, staticRenderFns } from "./PlayerRemoveButton.vue?vue&type=template&id=4a57c571&"
import script from "./PlayerRemoveButton.vue?vue&type=script&lang=js&"
export * from "./PlayerRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports